import { Button, useNotify, useRefresh } from "react-admin";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { paymentRequests } from "api/paymentApi";

const ApproveCashPaymentModal = ({ transaction, disabled }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async () => {
    await dataProvider.customRequest(paymentRequests.payCashPayment(transaction.transactionId), null, "POST");
    notify("Успешно одобрено плащане.", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      size="small"
      titleContent="Одобри плащане"
      onConfirm={handleConfirm}
      message="Сигурен ли сте, че искате да одобрите това плащане?"
      triggerButton={
        <Button
          disabled={disabled}
          startIcon={<ThumbUpIcon />}
          variant="contained"
          size="medium"
          label="Одобри плащане"
        />
      }
    />
  );
};

export default ApproveCashPaymentModal;
